module.exports = __webpack_public_path__ + "img/location-en.7afc588d.svg";